export default "__VITE_PUBLIC_ASSET__fcfaff2b__"